import locales from "./locales/locales";
import router from './routes/routes'

export const UsersModule = {
    name: 'users',
    routes: router,
    locales: locales,
}